import PropTypes from 'prop-types';
import { TABLE_VIEWS } from '../../helper';
import { TabContainer, TabLabel, TabsContainer } from './OrderInvoice.style';

/**
 * Order preparation vs Suggest alternatives tabs. Caller owns state via `value` / `onChange`.
 * Use `tabsContainerStyle` for layout inside nested sections (e.g. self-insurance blocks).
 */
const InvoiceAlternativesTabSwitcher = ({ enabled, value, onChange, tabsContainerStyle }) => {
  if (!enabled) return null;

  return (
    <TabsContainer style={tabsContainerStyle}>
      <TabContainer
        onClick={() => onChange(TABLE_VIEWS.ORDER_PREPARATION)}
        selected={value === TABLE_VIEWS.ORDER_PREPARATION}
      >
        <TabLabel>Order Preparation</TabLabel>
      </TabContainer>
      <TabContainer
        onClick={() => onChange(TABLE_VIEWS.SUGGEST_ALTERNATIVES)}
        selected={value === TABLE_VIEWS.SUGGEST_ALTERNATIVES}
      >
        <TabLabel>Alternatives</TabLabel>
      </TabContainer>
    </TabsContainer>
  );
};

InvoiceAlternativesTabSwitcher.propTypes = {
  enabled: PropTypes.bool,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tabsContainerStyle: PropTypes.shape({}),
};

InvoiceAlternativesTabSwitcher.defaultProps = {
  enabled: true,
  tabsContainerStyle: undefined,
};

export default InvoiceAlternativesTabSwitcher;
